


































import { Component, Vue, Prop } from 'vue-property-decorator';
import SummaryOverview from '@/pdf/components/SummaryOverview.vue';
import PageFooter from '@/pdf/components/PageFooter.vue';
import Compass from '@/components/Compass.vue';

@Component ({
  components: {
    SummaryOverview,
    PageFooter,
    Compass },
})
export default class CompanyCompass extends Vue {
  @Prop() readonly doc!: any;
}
